import ko, { Computed } from 'knockout';

export default function koDeferredComputed<T>(evaluatorFunction: () => T): Computed<T> {
	return ko.computed(evaluatorFunction, null, {
		deferEvaluation: true
	});
}
